// UT Austin's undergraduate majors (#2596, founder 2026-09-30: "majors offered
// by the college in the public page"). Read on 2026-09-30 from the official
// Undergraduate Catalog's Degree Programs page (catalog.utexas.edu/
// undergraduate/the-university/degree-programs/), which lists every major by
// college or school with the degree(s) it leads to. A major with more than
// one degree (Economics: BA and BSEco) is one row per degree. The catalog's
// parenthetical descriptions (joint offerings, specializations) become the
// major's note. Joint majors appear under each school that lists them, as
// the catalog does. Pharmacy (PharmD) is left out: it is a professional
// doctorate, not a bachelor's degree. Names and degree codes are as the
// catalog prints them, lower case included; typography is plain ASCII. The
// KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "university-of-texas-at-austin",
    "read": "2026-09-30",
    "intro": "Every undergraduate major in UT Austin's official Undergraduate Catalog, grouped by the college or school that offers it, with the degree it leads to. Minors, certificates, dual and integrated degree programs, and the PharmD are left out.",
    "groups": [
        {
            "name": "School of Architecture",
            "source": {
                "label": "UT Austin Undergraduate Catalog 2026-2027, Degree Programs",
                "url": "https://catalog.utexas.edu/undergraduate/the-university/degree-programs/"
            },
            "majors": [
                {
                    "name": "Architectural studies",
                    "degree": "BSAS"
                },
                {
                    "name": "Architecture",
                    "degree": "BArch"
                },
                {
                    "name": "Interior design",
                    "degree": "BSID"
                }
            ]
        },
        {
            "name": "Red McCombs School of Business",
            "source": {
                "label": "UT Austin Undergraduate Catalog 2026-2027, Degree Programs",
                "url": "https://catalog.utexas.edu/undergraduate/the-university/degree-programs/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Business administration",
                    "degree": "BBA"
                },
                {
                    "name": "Business analytics",
                    "degree": "BBA"
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "International business",
                    "degree": "BBA"
                },
                {
                    "name": "Management",
                    "degree": "BBA"
                },
                {
                    "name": "Management informations systems",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Supply chain management",
                    "degree": "BBA"
                }
            ]
        },
        {
            "name": "School of Civic Leadership",
            "source": {
                "label": "UT Austin Undergraduate Catalog 2026-2027, Degree Programs",
                "url": "https://catalog.utexas.edu/undergraduate/the-university/degree-programs/"
            },
            "majors": [
                {
                    "name": "Civics honors",
                    "degree": "BA"
                },
                {
                    "name": "Great books",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Moody College of Communication",
            "source": {
                "label": "UT Austin Undergraduate Catalog 2026-2027, Degree Programs",
                "url": "https://catalog.utexas.edu/undergraduate/the-university/degree-programs/"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": "BSAdv"
                },
                {
                    "name": "Communication and leadership",
                    "degree": "BSComm&Lead"
                },
                {
                    "name": "Communication studies",
                    "degree": "BSCommStds"
                },
                {
                    "name": "Journalism",
                    "degree": "BJ"
                },
                {
                    "name": "Public relations",
                    "degree": "BSPR"
                },
                {
                    "name": "Radio-television-film",
                    "degree": "BSRTF"
                },
                {
                    "name": "Speech, language, and hearing sciences",
                    "degree": "BSSLH"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "UT Austin Undergraduate Catalog 2026-2027, Degree Programs",
                "url": "https://catalog.utexas.edu/undergraduate/the-university/degree-programs/"
            },
            "majors": [
                {
                    "name": "Applied movement science",
                    "degree": "BSKin&Health"
                },
                {
                    "name": "Athletic training",
                    "degree": "BSAthTrng"
                },
                {
                    "name": "Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Exercise science",
                    "degree": "BSKin&Health"
                },
                {
                    "name": "Health promotion and behavioral science",
                    "degree": "BSKin&Health"
                },
                {
                    "name": "Physical culture and sports studies",
                    "degree": "BSKin&Health"
                },
                {
                    "name": "Sport management",
                    "degree": "BSKin&Health"
                },
                {
                    "name": "Youth and community studies",
                    "degree": "BSEd"
                }
            ]
        },
        {
            "name": "Cockrell School of Engineering",
            "source": {
                "label": "UT Austin Undergraduate Catalog 2026-2027, Degree Programs",
                "url": "https://catalog.utexas.edu/undergraduate/the-university/degree-programs/"
            },
            "majors": [
                {
                    "name": "Aerospace engineering",
                    "degree": "BSAsE"
                },
                {
                    "name": "Architectural engineering",
                    "degree": "BSArchE"
                },
                {
                    "name": "Biomedical engineering",
                    "degree": "BSBiomedE"
                },
                {
                    "name": "Chemical engineering",
                    "degree": "BSChE"
                },
                {
                    "name": "Civil engineering",
                    "degree": "BSCE"
                },
                {
                    "name": "Computational engineering",
                    "degree": "BSCompE"
                },
                {
                    "name": "Electrical and computer engineering",
                    "degree": "BSECE"
                },
                {
                    "name": "Environmental engineering",
                    "degree": "BSEnvE"
                },
                {
                    "name": "Geosystems engineering",
                    "degree": "BSGE",
                    "note": "Offered jointly by the Hildebrand Department of Petroleum and Geosystems Engineering and the Jackson School of Geosciences."
                },
                {
                    "name": "Mechanical engineering",
                    "degree": "BSME"
                },
                {
                    "name": "Petroleum engineering",
                    "degree": "BSPE"
                }
            ]
        },
        {
            "name": "College of Fine Arts",
            "source": {
                "label": "UT Austin Undergraduate Catalog 2026-2027, Degree Programs",
                "url": "https://catalog.utexas.edu/undergraduate/the-university/degree-programs/"
            },
            "majors": [
                {
                    "name": "Acting",
                    "degree": "BFA"
                },
                {
                    "name": "Art education",
                    "degree": "BFA"
                },
                {
                    "name": "Art history",
                    "degree": "BAArtHist"
                },
                {
                    "name": "Arts and entertainment technologies",
                    "degree": "BSAET"
                },
                {
                    "name": "Composition",
                    "degree": "BMusic"
                },
                {
                    "name": "Dance",
                    "degree": "BFA"
                },
                {
                    "name": "Design",
                    "degree": "BADesign"
                },
                {
                    "name": "Design",
                    "degree": "BFA"
                },
                {
                    "name": "Jazz",
                    "degree": "BMusic",
                    "note": "Emphasis in composition or performance: double bass, drum set, guitar, piano, saxophone, trombone, and trumpet."
                },
                {
                    "name": "Music",
                    "degree": "BAMusic"
                },
                {
                    "name": "Music education",
                    "degree": "BMusic"
                },
                {
                    "name": "Music performance",
                    "degree": "BMusic",
                    "note": "Students may major in voice, piano, organ, harpsichord, harp, or one of the orchestral instruments, including euphonium, guitar, and saxophone."
                },
                {
                    "name": "Studio art",
                    "degree": "BAStudioArt"
                },
                {
                    "name": "Studio art",
                    "degree": "BFA"
                },
                {
                    "name": "Theatre and dance",
                    "degree": "BATD"
                },
                {
                    "name": "Theatre education",
                    "degree": "BFA"
                }
            ]
        },
        {
            "name": "John A. and Katherine G. Jackson School of Geosciences",
            "source": {
                "label": "UT Austin Undergraduate Catalog 2026-2027, Degree Programs",
                "url": "https://catalog.utexas.edu/undergraduate/the-university/degree-programs/"
            },
            "majors": [
                {
                    "name": "Climate system science",
                    "degree": "BSGS"
                },
                {
                    "name": "General geology",
                    "degree": "BSGS"
                },
                {
                    "name": "Geophysics",
                    "degree": "BSGS"
                },
                {
                    "name": "Geosciences",
                    "degree": "BAGS"
                },
                {
                    "name": "Geosciences",
                    "degree": "BSEnvirSci"
                },
                {
                    "name": "Geosciences",
                    "degree": "BSGS"
                },
                {
                    "name": "Geosystems engineering",
                    "degree": "BSGE",
                    "note": "Offered jointly with the Cockrell School of Engineering."
                },
                {
                    "name": "Hydrology and water resources",
                    "degree": "BSGS"
                }
            ]
        },
        {
            "name": "College of Liberal Arts",
            "source": {
                "label": "UT Austin Undergraduate Catalog 2026-2027, Degree Programs",
                "url": "https://catalog.utexas.edu/undergraduate/the-university/degree-programs/"
            },
            "majors": [
                {
                    "name": "African and African diaspora studies",
                    "degree": "BA"
                },
                {
                    "name": "American studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Asian cultures and languages",
                    "degree": "BA",
                    "note": "Students specialize in Chinese, Hindi/Urdu, Japanese, Korean, Malayalam, Sanskrit, or Tamil."
                },
                {
                    "name": "Asian studies",
                    "degree": "BA"
                },
                {
                    "name": "Behavioral and social data science",
                    "degree": "BSBSDS"
                },
                {
                    "name": "Classical languages",
                    "degree": "BA",
                    "note": "Students specialize in classics, Greek, or Latin."
                },
                {
                    "name": "Classical studies",
                    "degree": "BA",
                    "note": "Students specialize in ancient history or classical archaeology."
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BSEco"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Ethnic studies",
                    "degree": "BA",
                    "note": "Students majoring in ethnic studies concentrate in Asian American studies."
                },
                {
                    "name": "European studies",
                    "degree": "BA"
                },
                {
                    "name": "French studies",
                    "degree": "BA"
                },
                {
                    "name": "Geographical sciences",
                    "degree": "BSEnvirSci"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "Government",
                    "degree": "BA"
                },
                {
                    "name": "Health and society",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History and Computer Science",
                    "degree": "BSHisCS",
                    "note": "Offered jointly with the College of Natural Sciences."
                },
                {
                    "name": "Human dimensions of organizations",
                    "degree": "BA"
                },
                {
                    "name": "Humanities",
                    "degree": "BA"
                },
                {
                    "name": "International relations and global studies",
                    "degree": "BA"
                },
                {
                    "name": "Italian studies",
                    "degree": "BA"
                },
                {
                    "name": "Jewish studies",
                    "degree": "BA"
                },
                {
                    "name": "Latin American studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics and Computer Science",
                    "degree": "BSLinCS",
                    "note": "Offered jointly with the College of Natural Sciences."
                },
                {
                    "name": "Mexican American and Latina/o studies",
                    "degree": "BA"
                },
                {
                    "name": "Middle Eastern studies",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Plan II honors program",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BSPsy"
                },
                {
                    "name": "Race, indigeneity, and migration",
                    "degree": "BA"
                },
                {
                    "name": "Religious studies",
                    "degree": "BA"
                },
                {
                    "name": "Rhetoric and writing",
                    "degree": "BA"
                },
                {
                    "name": "Russian, East European, and Eurasian studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Sustainability studies",
                    "degree": "BA"
                },
                {
                    "name": "Urban studies",
                    "degree": "BA"
                },
                {
                    "name": "Women's and gender studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Natural Sciences",
            "source": {
                "label": "UT Austin Undergraduate Catalog 2026-2027, Degree Programs",
                "url": "https://catalog.utexas.edu/undergraduate/the-university/degree-programs/"
            },
            "majors": [
                {
                    "name": "Astronomy",
                    "degree": "BA"
                },
                {
                    "name": "Astronomy",
                    "degree": "BSA"
                },
                {
                    "name": "Astronomy",
                    "degree": "BSAst"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BSBioch"
                },
                {
                    "name": "Biological sciences",
                    "degree": "BSEnvirSci"
                },
                {
                    "name": "Biology",
                    "degree": "BSA"
                },
                {
                    "name": "Biology",
                    "degree": "BSBio"
                },
                {
                    "name": "Chemistry",
                    "degree": "BSA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BSCh"
                },
                {
                    "name": "Computer science",
                    "degree": "BSA"
                },
                {
                    "name": "Computer science",
                    "degree": "BSCompSci"
                },
                {
                    "name": "History and Computer Science",
                    "degree": "BSHisCS",
                    "note": "Offered jointly by the College of Liberal Arts and the Department of Computer Science."
                },
                {
                    "name": "Human development and family sciences",
                    "degree": "BSA"
                },
                {
                    "name": "Human development and family sciences",
                    "degree": "BSHDFS"
                },
                {
                    "name": "Human ecology",
                    "degree": "BSA"
                },
                {
                    "name": "Informatics",
                    "degree": "BA"
                },
                {
                    "name": "Informatics",
                    "degree": "BSI"
                },
                {
                    "name": "Linguistics and Computer Science",
                    "degree": "BSLinCS",
                    "note": "Offered jointly by the College of Liberal Arts and the Department of Computer Science."
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BSA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BSMath"
                },
                {
                    "name": "Medical laboratory science",
                    "degree": "BSMedLabSci"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BSA"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BSNeurosci"
                },
                {
                    "name": "Neuroscience and Computer Science",
                    "degree": "BSNeuCS",
                    "note": "Offered jointly by the Department of Neuroscience and the Department of Computer Science."
                },
                {
                    "name": "Nutrition",
                    "degree": "BSA"
                },
                {
                    "name": "Nutrition",
                    "degree": "BSNtr"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BSA"
                },
                {
                    "name": "Physics",
                    "degree": "BSPhy"
                },
                {
                    "name": "Public health",
                    "degree": "BSPublichealth"
                },
                {
                    "name": "Statistics and data science",
                    "degree": "BSSDS"
                },
                {
                    "name": "Textiles and apparel",
                    "degree": "BSTA"
                }
            ]
        },
        {
            "name": "School of Nursing",
            "source": {
                "label": "UT Austin Undergraduate Catalog 2026-2027, Degree Programs",
                "url": "https://catalog.utexas.edu/undergraduate/the-university/degree-programs/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "Lyndon B. Johnson School of Public Affairs",
            "source": {
                "label": "UT Austin Undergraduate Catalog 2026-2027, Degree Programs",
                "url": "https://catalog.utexas.edu/undergraduate/the-university/degree-programs/"
            },
            "majors": [
                {
                    "name": "Public Affairs",
                    "degree": "BAPubAff"
                }
            ]
        },
        {
            "name": "School of Social Work",
            "source": {
                "label": "UT Austin Undergraduate Catalog 2026-2027, Degree Programs",
                "url": "https://catalog.utexas.edu/undergraduate/the-university/degree-programs/"
            },
            "majors": [
                {
                    "name": "Social work",
                    "degree": "BSW"
                }
            ]
        },
        {
            "name": "Undergraduate Studies",
            "source": {
                "label": "UT Austin Undergraduate Catalog 2026-2027, Degree Programs",
                "url": "https://catalog.utexas.edu/undergraduate/the-university/degree-programs/"
            },
            "majors": [
                {
                    "name": "Strategy and Statecraft",
                    "degree": "BA",
                    "note": "Offered through the Clements Center for National Security in partnership with the School of Civic Leadership."
                }
            ]
        }
    ]
};

export default majors;
